$( document ).ready(function() {

    initCart();
    loadCart();
    //initButtonChangeQuantityOnProductPage();
    //initUpdateQuantityOnCartPage();

    initButtonChangeQuantityOnProductPage();
});

function loadCart() {
    jQuery.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'jsonp',
        success: function(data) {

            var item_count = data['item_count'];
            var total_price = data['total_price']/100;
            var cart_has_subscibe_product = 0;

            //If there are items in cart
            if ( item_count > 0 ) {

                // cart count
                jQuery('.cart-count').text(item_count);

                // mini cart data
                jQuery('.mini-cart').attr('id','mini-cart');
                jQuery('.mini-cart-subtotal').text('$'+ total_price.toFixed(0));

                var cart_list = [];

                for( var i = 0; i < item_count; i++ ){
                    if(data['items'][i]) {
                        if (data['items'][i]['id']) {

                            var item_id = data['items'][i]['id'];
                            var product_title = data['items'][i]['title'];
                            var product_handle = data['items'][i]['handle'];
                            var quantity = data['items'][i]['quantity'];
                            var line_price = data['items'][i]['price'] / 100;
                            var product_url = data['items'][i]['url'];
                            var image_url = data['items'][i]['image'];
                            var variants = data['items'][i]['variant_options'];
                            var product_oz = Math.ceil(data['items'][i]['grams']/28.34952);
                            var variant_title = data['items'][i]['variant_title'];

                            var options = [];
                            for (var o = 0; o < variants.length; o++) {
                                var selected = data['items'][i]['variant_options'][o];
                                if (selected !== 'Default Title') {
                                    options.push(selected + '<br>');
                                }
                            }
                            var selected_options = options.join('');

                            var min_quantity = 1;

                            var html = '<div class="item-row">' +
                                '            <div class="image-wrap">' +
                                '                <a href="' + product_url + '"><img src="' + image_url + '" /></a>' +
                                '                <span class="remove-item remove-item-from-cart" data-productId="' + item_id + '"></span>' +
                                '            </div>' +
                                '            <div class="meta-row">' +
                                '                <span class="name"><span>' + product_title + '</span></span>' +
                                '                   <div class="quantity-wrap change_product_count" data-min-quantity="' + min_quantity + '"  data-variant="' + data['items'][i]['variant_id'] + '">' +
                                '                       <span class="minus button-quantity-change cart-button-quantity-change icon-minus"></span>' +
                                '                       <input type="number"  class="input product_selected_quantity"  id="product_quantity_' + data['items'][i]['variant_id']  + '" value="' + quantity + '" disabled />' +
                                '                       <span class="plus button-quantity-change cart-button-quantity-change icon-plus"></span>' +
                                '                   </div>' +
                                '                <span class="price">$' + line_price.toFixed(0) + '</span>' +
                                '            </div>' +
                                '        </div>';

                            cart_list.push(html);
                        } //endif
                    }
                } // endfor

                jQuery('.mini-products-list').html( cart_list.join('') );
                $('.no-items-in-cart').hide();

                jQuery('.remove-item-from-cart').on('click',function(){
                    var product_variant_id = $(this).attr('data-productId');
                    $(this).parent().parent().remove();
                    removeItemCountInCart(product_variant_id,0);
                });

                jQuery('.change_product_count .cart-button-quantity-change').on('click', function(){
                    $('.mini-products-list').hide();

                    var product_variant_id = $(this).closest('.change_product_count').attr('data-variant');
                    var current_element_quantity = parseInt($('#product_quantity_' + product_variant_id).val());
                    var current_element_properties = $(this).closest('.change_product_count').attr('data-properties');
                    var current_element_min_quantity = $(this).closest('.change_product_count').attr('data-min-quantity');

                    if($(this).hasClass('icon-plus')) {
                        var subscribe_item = $(this).data('subscribe_item');
                        var new_element_quantity = current_element_quantity + 1;
                        updateItemCountInCart(product_variant_id, new_element_quantity, current_element_properties, subscribe_item);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }else{
                        var new_element_quantity = current_element_quantity - 1;
                        removeItemCountInCart(product_variant_id,new_element_quantity);
                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                    }
                });

                $('.mini-products-list').show();
                $('.loadingCart').hide();
            }else{
                $('.loadingCart').hide();
                $('.mini-products-list').empty().show();
                $('.no-items-in-cart').show();
                $('.mini-cart-subtotal').text('');
            }
        }
    });
}

function initCart() {
    jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(data) {

            var item_counts_in_cart = data.items.length;
            var total_items_in_cart = data.item_count;


            var total_sum_in_cart = data.total_price/100;

            // if(total_sum_in_cart<free_shipping_sum) {
            //     $('.cart-menu-progress').show();
            //     var proc_sum = free_shipping_sum / 100;
            //     var total_proc_in_cart = total_sum_in_cart / proc_sum;
            //     var rest_sum = free_shipping_sum - total_sum_in_cart;
            //     $('#small_cart_progress_bar').css('width',total_proc_in_cart+'%')
            //     $('#small_cart_rest_sum').text('$' + rest_sum);
            // }else{
            //     $('.cart-menu-progress').hide();
            // }

            if(item_counts_in_cart>0) {

                 $('.header-quantity').text(total_items_in_cart);
                 $('.no-items-in-cart').hide();
                 $('.small-cart-checkout-button').show();
                 $('.checkout-button').show();
                 $('.checkout-button.shop-now').hide();
                 $('.total-wrap').show();
            }else{
                 $('.no-items-in-cart').css('display', 'flex');
                 $('.header-quantity').text(0);
                 $('.mini-products-list').empty();
                 $('.mini-cart-subtotal').text('');
                 // $('.small-cart-checkout-button').hide();
                 $('.checkout-button').hide();
                 $('.checkout-button.shop-now').css('display', 'flex');
                 $('.total-wrap').hide();
            }
        }
    });
}

function initButtonChangeQuantityOnProductPage() {
    $('.button-quantity-change').on('click', function(){

        var product_id = $(this).data('product_id');
        var selected_qty = parseInt($('#product_selected_quantity').val());
        var max_qty = parseInt($('#product_max_qnty').val());
        var min_qty = 1;

        var new_qty = selected_qty * 1;

        if($(this).hasClass('icon-plus')) {
            if(max_qty>selected_qty) {
                new_qty++;
            }
        }else{
            if(new_qty>1) {
                new_qty--;
            }
        }
        new_qty = (isNaN(new_qty))?1:new_qty;

        if(new_qty<min_qty){
            new_qty = min_qty;
        }

        $('#product_selected_quantity').val(new_qty);

    });
}

function removeItemCountInCart(variant_id,new_count, reload) {

    var data = {
        'id': variant_id,
        'quantity': new_count
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function(data) {
            initCart();
            loadCart();
            if(reload == 1 || document.location.pathname=='/cart'){
                document.location.reload();
            }
        },
        error: function(error) {
            alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            initCart();
            loadCart();
        }

    });
}

function initUpdateQuantityOnCartPage(){
    $('.cart-quantity-update').on('click', function(){
        $('.cart-loading').show();
        $('.product-cart-row').hide();

        var product_id = $(this).data('product_id');
        var variant_id = $('#cart_product_variant_id_' + product_id).val();

        var current_element_quantity = parseInt($('#product_selected_quantity_' + product_id).val());

        if($(this).hasClass('icon-plus')) {
            updateItemCountInCart(variant_id, current_element_quantity, '', '', 1);
        }else{
            if($(this).hasClass('delete-item-from-cart')){
                current_element_quantity = 0;
            }

            removeItemCountInCart(variant_id, current_element_quantity, 1);
        }

    });
}

function updateItemCountInCart(variant_id,new_count, properties, subscribe_item, reload) {

        var data = {
            "id": variant_id,
            "quantity": new_count
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function(data) {
                initCart();
                loadCart();
                if(reload == 1 || document.location.pathname=='/cart'){
                    document.location.reload();
                }
            },
            error: function(error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
                initCart();
                loadCart();
            }
        });

}

function showSmallCart(){
    $('.cart-btn').click();
}

function addItemToCart() {

    var qty = parseInt($('#product_selected_quantity').val());
    var variant_id = $('#product_variant_id').val();
    var inventory_available = $('#inventory_available').val();

    if(inventory_available == 1) {
        if (!qty) {
            qty = 1;
        }

        var data = {
            "id": variant_id,
            "quantity": qty
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                initCart();
                loadCart();
                showSmallCart();
            },
            error: function (error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }

}
function addSubscribeItemToCart(variant_id, product_id) {

    if(product_id>0){
        var qty = parseInt($('#product_block_index_' + product_id + ' .product_selected_quantity').val());
        var properties = $('#product_block_index_' + product_id + ' .product_extra_properties').val();
        var selling_plan = $('#product_block_index_' + product_id + ' input[name="selling_plan"]').val();
        var min_quantity = $('#product_min_quantity_' + product_id).val();
    }else {
        var qty = parseInt($('#product_selected_quantity').val());
        var properties = $('.product_extra_properties').val();
        var selling_plan = $('input[name="selling_plan"]').val();
        var min_quantity = $('.product_min_quantity').val();
    }

    if(!qty){
        qty = 1;
    }

    if(qty<min_quantity){
        qty = min_quantity;
    }

    setTimeout(function() {
        if(properties!='') {
            var data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": selling_plan,
                "properties": { properties }
            }
        }else{
            var data = {
                "id": variant_id,
                "quantity": qty,
                "selling_plan": selling_plan
            }
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                initCart();
                loadCart();
                showSmallCart();
            },
            error: function(error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }, 100);

}

function quickAddItemToCart(section_id) {
    var variant_id = 0;

    $('#' + section_id + ' .quick-add-to-cart').each(function(){
       if($(this).hasClass('active')){
           variant_id = $(this).data('active-variant-id');
       }
    });

    if(variant_id>0) {
        var data = {
            "id": variant_id,
            "quantity": 1
        }

        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function () {
                initCart();
                loadCart();
                showSmallCart();
            },
            error: function (error) {
                alert(error.responseJSON.message + '\r\n' + error.responseJSON.description);
            }
        });
    }else{
        alert('Error. Can\'t add this product to cart!');
    }
}
